<mat-accordion>
    <mat-expansion-panel [expanded]="panelOpenState">
        <mat-expansion-panel-header>
            <mat-panel-title> {{ 'aumico_admin_translations_groups' | i18next }} </mat-panel-title>
            <mat-icon class="icon" svgIcon="aumico-pattern-icon-check-circle" *ngIf="isCompleted"></mat-icon>
            <mat-icon class="icon" svgIcon="aumico-pattern-icon-wrong-circle" *ngIf="!isCompleted"></mat-icon>
        </mat-expansion-panel-header>
        <form [formGroup]="formGroup">
            <table mat-table [dataSource]="translationsFormArray.controls" class="table table-sm table-bordered">
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef style="width: 300px">
                        {{ 'aumico_admin_translations_name_column_header' | i18next }}
                    </th>
                    <td mat-cell *matCellDef="let rowFormGroup" [formGroup]="rowFormGroup">
                        {{ rowFormGroup['controls']['name'].value }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="currentLocale">
                    <th mat-header-cell *matHeaderCellDef>{{ currentLocale }}</th>
                    <td mat-cell *matCellDef="let rowFormGroup" [formGroup]="rowFormGroup">
                        <aum-input [aumFormControl]="rowFormGroup['controls'][currentLocale]"></aum-input>
                    </td>
                </ng-container>

                <ng-container matColumnDef="selectedLocale">
                    <th mat-header-cell *matHeaderCellDef>{{ selectedLocaleValue }}</th>
                    <td mat-cell *matCellDef="let rowFormGroup" [formGroup]="rowFormGroup">
                        <aum-input [aumFormControl]="rowFormGroup['controls'][selectedLocaleValue]"></aum-input>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        </form>
    </mat-expansion-panel>
</mat-accordion>
